import React, { Fragment } from "react";
import Image from "react-bootstrap/Image";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";

const MapSetupScreenTwoWrapper = ({ localProps, state, ...props }) => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
          >
            {/* <div className="col-12 onboarding_process_screen_left-backbutton">
              <NavLink to="/mapsetup" className="back_button-link">
                <Image
                  src={require("../../../../assets/images/Icon/onBoardBack.png")}
                  alt="Back Button"
                  title="Back Button"
                />
              </NavLink>
            </div> */}
            <Media query="(min-width: 992px)">
              <div className="col-12">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  backButtonClicked="/mapsetup"
                />
              </div>
            </Media>
            <Media query="(max-width: 991px)">
              <MobileTopHeader link={true} onLink={"/mapsetup"} />
            </Media>
            <div className="onboarding_process_screen-left-mapinside">
              <div>
                <TopTextReusableComponent
                  headingText="Map Setup"
                  headingParagraph="Business names on Amealio need to be written as they appear on the board outside the restaurant"
                />
              </div>
              <div className="row justify-content-between align-items-center py-4">
                <h5 className="f12-400 col-7">
                  Drop a pin to your address Move the marker as required
                </h5>
                <div className="pl-0 col-5 d-flex align-items-center justify-content-end">
                  <div
                    className="d-flex align-items-center AutoDetectBtn"
                    onClick={localProps.onAutoDetectHandler}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/map-pin-red.svg")}
                      fluid
                      alt="Auto Detect"
                      title="Auto Detect Location"
                      className="location-detections-popup-map-search"
                    />
                    <p className="f12-500 text-red">Auto Detect Location</p>
                  </div>
                </div>
              </div>

              {props.children}
              <div className="onboarding-map-setup-screen-autodetect-button">
                {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  link="/mapsetup"
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonText="Next"
                  buttonType="button"
                  onClick={
                    state.actionButton === false
                      ? localProps.onWhitOutApiCall
                      : localProps.onSubmitHandler
                  }
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                />
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              displayBarButton={true}
              displayHamburger={true}
              selectedProgressBarOne="active"
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-07.svg")}
            />
          </div>
          {/* <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 onboarding_process_screen_right">
            <RightSidePannel
              selectedTab={1}
              headingText="Store Setup"
              imageSrc={require("../../../../assets/images/onboarding/storeSetup.svg")}
              paragraph="Enter information diligently about your food establishment. Users
                  would like to know about your restaurant listed on our app. Take your
                  time and fill information carefully"
            />
          </div> */}
        </div>
      </div>
    </Fragment>
  );
};

export default MapSetupScreenTwoWrapper;
